import { Box, styled, TextField } from '@mui/material';
import { ValidationTextFieldColor } from 'src/utils';

export const Wrapper = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InputBox = styled(TextField)(
  ({ theme, status }) => `
  width: 100%;

  & .MuiOutlinedInput-input {
    border: 1px solid ${theme?.palette?.brand?.disable};
    border-radius: inherit;
  }

  .Mui-disabled {
    background-color: ${theme?.palette?.brand?.disabled};
  }
  .MuiOutlinedInput-root fieldset {
    border-color: ${
      status === 'input'
        ? theme.palette.primary.main
        : ValidationTextFieldColor(status)
    };
  }
    & .MuiOutlinedInput-root.Mui-error fieldset {
    border-color: ${theme.palette.error.main} !important;
  }
`,
);
